(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gilboard-scroll-story"] && !Shopify.designMode) return;
  try {
    

(function () {

  var SELECTOR =
    '[data-gilboard-scroll-story]';


  function clamp(
    value,
    min,
    max
  ) {

    return Math.min(
      Math.max(
        value,
        min
      ),
      max
    );

  }


  function smoothstep(
    value
  ) {

    value =
      clamp(
        value,
        0,
        1
      );


    return (
      value *
      value *
      (
        3 -
        2 *
        value
      )
    );

  }


  function rangeProgress(
    progress,
    start,
    end
  ) {

    if (
      start === end
    ) {
      return 0;
    }


    return clamp(
      (
        progress -
        start
      ) /
      (
        end -
        start
      ),
      0,
      1
    );

  }


  function fadeWindow(
    progress,
    start,
    fadeInEnd,
    fadeOutStart,
    end
  ) {

    if (
      progress <= start ||
      progress >= end
    ) {
      return 0;
    }


    if (
      progress < fadeInEnd
    ) {

      return smoothstep(
        rangeProgress(
          progress,
          start,
          fadeInEnd
        )
      );

    }


    if (
      progress <= fadeOutStart
    ) {
      return 1;
    }


    return (
      1 -
      smoothstep(
        rangeProgress(
          progress,
          fadeOutStart,
          end
        )
      )
    );

  }


  function setOpacity(
    element,
    value
  ) {

    if (!element) return;


    element.style.opacity =
      clamp(
        value,
        0,
        1
      );

  }


  function setFeature(
    element,
    opacity
  ) {

    if (!element) return;


    opacity =
      clamp(
        opacity,
        0,
        1
      );


    var y =
      (
        1 -
        opacity
      ) *
      28;


    element.style.opacity =
      opacity;


    element.style.transform =
      'translate(-50%,' +
      y +
      'px)';

  }


  function initGilboard(
    section
  ) {

    if (!section) return;


    if (
      section.dataset.gbsInitialized ===
      'true'
    ) {
      return;
    }


    section.dataset.gbsInitialized =
      'true';


    var background =
      section.querySelector(
        '.gbs-background-image'
      );


    var backgroundFade =
      section.querySelector(
        '.gbs-background-fade'
      );


    var boardStage =
      section.querySelector(
        '.gbs-board-stage'
      );


    var green =
      section.querySelector(
        '.gbs-board-green'
      );


    var rose =
      section.querySelector(
        '.gbs-board-rose'
      );


    var blue =
      section.querySelector(
        '.gbs-board-blue'
      );


    var beige =
      section.querySelector(
        '.gbs-board-beige'
      );


    var intro =
      section.querySelector(
        '.gbs-intro'
      );


    var introActions =
      section.querySelector(
        '.gbs-intro-actions'
      );


    var feature1 =
      section.querySelector(
        '.gbs-feature-1'
      );


    var feature2 =
      section.querySelector(
        '.gbs-feature-2'
      );


    var feature3 =
      section.querySelector(
        '.gbs-feature-3'
      );


    var feature4 =
      section.querySelector(
        '.gbs-feature-4'
      );


    var magnets =
      section.querySelectorAll(
        '.gbs-magnet'
      );


    var drawing =
      section.querySelector(
        '.gbs-drawing'
      );


    var drawingPaths =
      section.querySelectorAll(
        '.gbs-draw-path'
      );


    var wipeSystem =
      section.querySelector(
        '.gbs-wipe-system'
      );


    var finalScene =
      section.querySelector(
        '.gbs-final-scene'
      );


    var finalSceneImage =
      section.querySelector(
        '.gbs-final-scene-image'
      );


    var finalCopy =
      section.querySelector(
        '.gbs-final-copy'
      );


    var active = true;

    var frame = null;


    function setMobileState() {

      if (finalScene) {
        finalScene.style.opacity =
          '1';
      }


      if (finalSceneImage) {
        finalSceneImage.style.transform =
          'none';
      }


      if (finalCopy) {

        finalCopy.style.opacity =
          '1';

        finalCopy.style.transform =
          'translate(-50%,0)';

        finalCopy.style.pointerEvents =
          'auto';

      }

    }


    function update() {

      if (!active) return;


      /*
        =================================================
        MOBILE
        KEINE SCROLL-ANIMATION
        =================================================
      */

      if (
        window.matchMedia(
          '(max-width: 749px)'
        ).matches
      ) {

        setMobileState();

        return;

      }


      /*
        =================================================
        AB HIER NUR DESKTOP
        =================================================
      */


      var rect =
        section.getBoundingClientRect();


      var viewport =
        window.innerHeight;


      var distance =
        section.offsetHeight -
        viewport;


      if (
        distance <= 0
      ) {
        return;
      }


      var travelled =
        clamp(
          -rect.top,
          0,
          distance
        );


      var progress =
        travelled /
        distance;


      /* =================================================
         INTRO
      ================================================== */

      if (background) {

        var camera =
          smoothstep(
            rangeProgress(
              progress,
              0,
              .14
            )
          );


        background.style.transform =
          'translate3d(0,' +
          (
            camera *
            -1.2
          ) +
          '%,0) scale(' +
          (
            1 +
            camera *
            .055
          ) +
          ')';

      }


      if (backgroundFade) {

        var whiteFade =
          smoothstep(
            rangeProgress(
              progress,
              .03,
              .15
            )
          );


        backgroundFade.style.opacity =
          whiteFade *
          .96;

      }


      var introOpacity =
        1 -
        smoothstep(
          rangeProgress(
            progress,
            .03,
            .12
          )
        );


      if (intro) {

        intro.style.opacity =
          introOpacity;


        intro.style.transform =
          'translate(-50%,' +
          (
            (
              1 -
              introOpacity
            ) *
            -30
          ) +
          'px)';

      }


      /* =================================================
         START-BUTTONS
      ================================================== */

      if (introActions) {

        var introActionsOpacity =
          1 -
          smoothstep(
            rangeProgress(
              progress,
              .02,
              .10
            )
          );


        introActions.style.opacity =
          introActionsOpacity;


        introActions.style.transform =
          'translate(-50%,' +
          (
            (
              1 -
              introActionsOpacity
            ) *
            -22
          ) +
          'px)';


        introActions.style.pointerEvents =
          introActionsOpacity >
          .08
          ? 'auto'
          : 'none';

      }


      /* =================================================
         BOARD ENTER
      ================================================== */

      var boardEnter =
        smoothstep(
          rangeProgress(
            progress,
            .035,
            .14
          )
        );


      var boardScale =
        .72 +
        (
          boardEnter *
          .28
        );


      var slowZoom =
        smoothstep(
          rangeProgress(
            progress,
            .14,
            .67
          )
        );


      boardScale +=
        slowZoom *
        .07;


      var finalBoardMove =
        smoothstep(
          rangeProgress(
            progress,
            .67,
            .80
          )
        );


      boardScale -=
        finalBoardMove *
        .09;


      var boardMoveX =
        finalBoardMove *
        1.5;


      var boardMoveY =
        finalBoardMove *
        -2;


      if (boardStage) {

        boardStage.style.transform =
          'translate(-50%,-50%) ' +
          'translate(' +
          boardMoveX +
          'vw,' +
          (
            (
              1 -
              boardEnter
            ) *
            55 +
            boardMoveY
          ) +
          'px) ' +
          'scale(' +
          boardScale +
          ')';

      }


      /* =================================================
         MAGNETISCH
      ================================================== */

      var feature1Opacity =
        fadeWindow(
          progress,
          .11,
          .14,
          .23,
          .27
        );


      setFeature(
        feature1,
        feature1Opacity
      );


      magnets.forEach(
        function(
          magnet,
          index
        ) {

          var start =
            .125 +
            index *
            .008;


          var magnetIn =
            smoothstep(
              rangeProgress(
                progress,
                start,
                start +
                .04
              )
            );


          var magnetOut =
            1 -
            smoothstep(
              rangeProgress(
                progress,
                .25,
                .285
              )
            );


          var opacity =
            magnetIn *
            magnetOut;


          magnet.style.opacity =
            opacity;


          magnet.style.transform =
            'translateY(' +
            (
              (
                1 -
                magnetIn
              ) *
              50
            ) +
            'px) ' +
            'scale(' +
            (
              .45 +
              magnetIn *
              .55
            ) +
            ') ' +
            'rotate(var(--gbs-rot, 0deg))';

        }
      );


      /* =================================================
         GRÜN -> ROSA
      ================================================== */

      var greenToRose =
        smoothstep(
          rangeProgress(
            progress,
            .245,
            .29
          )
        );


      setOpacity(
        green,
        1 -
        greenToRose
      );


      setOpacity(
        rose,
        greenToRose
      );


      /* =================================================
         BESCHREIBBAR
      ================================================== */

      var feature2Opacity =
        fadeWindow(
          progress,
          .265,
          .30,
          .38,
          .42
        );


      setFeature(
        feature2,
        feature2Opacity
      );


      var drawProgress =
        smoothstep(
          rangeProgress(
            progress,
            .28,
            .38
          )
        );


      drawingPaths.forEach(
        function(
          path,
          index
        ) {

          var stagger =
            index *
            .04;


          var localProgress =
            clamp(
              (
                drawProgress -
                stagger
              ) /
              (
                1 -
                stagger
              ),
              0,
              1
            );


          path.style.strokeDashoffset =
            1700 *
            (
              1 -
              localProgress
            );

        }
      );


      if (
        drawing &&
        progress <
        .43
      ) {

        drawing.style.opacity =
          drawProgress;


        drawing.style.clipPath =
          'inset(0 0 0 0)';

      }


      /* =================================================
         ROSA -> BLAU
      ================================================== */

      var roseToBlue =
        smoothstep(
          rangeProgress(
            progress,
            .39,
            .435
          )
        );


      setOpacity(
        rose,
        greenToRose *
        (
          1 -
          roseToBlue
        )
      );


      setOpacity(
        blue,
        roseToBlue
      );


      /* =================================================
         ABWISCHBAR
      ================================================== */

      var feature3Opacity =
        fadeWindow(
          progress,
          .405,
          .44,
          .57,
          .61
        );


      setFeature(
        feature3,
        feature3Opacity
      );


      var eraseProgress =
        smoothstep(
          rangeProgress(
            progress,
            .43,
            .60
          )
        );


      if (wipeSystem) {

        var wipeOpacity =
          fadeWindow(
            progress,
            .42,
            .435,
            .59,
            .615
          );


        wipeSystem.style.opacity =
          wipeOpacity;


        var wipeX =
          -50 +
          eraseProgress *
          100;


        wipeSystem.style.transform =
          'translateX(' +
          wipeX +
          '%)';

      }


      if (
        drawing &&
        progress >= .43 &&
        progress < .62
      ) {

        drawing.style.opacity =
          1;


        drawing.style.clipPath =
          'inset(0 0 0 ' +
          (
            eraseProgress *
            100
          ) +
          '%)';

      }


      /* =================================================
         BLAU -> BEIGE
      ================================================== */

      var blueToBeige =
        smoothstep(
          rangeProgress(
            progress,
            .575,
            .64
          )
        );


      setOpacity(
        blue,
        roseToBlue *
        (
          1 -
          blueToBeige
        )
      );


      setOpacity(
        beige,
        blueToBeige
      );


      if (
        drawing &&
        progress >= .62
      ) {

        drawing.style.opacity =
          0;

      }


      /* =================================================
         4 FARBEN
      ================================================== */

      var feature4Opacity =
        fadeWindow(
          progress,
          .59,
          .625,
          .68,
          .72
        );


      setFeature(
        feature4,
        feature4Opacity
      );


      /* =================================================
         FINALE SZENE
      ================================================== */

      var sceneIn =
        smoothstep(
          rangeProgress(
            progress,
            .70,
            .82
          )
        );


      if (finalScene) {

        finalScene.style.opacity =
          sceneIn;

      }


      if (finalSceneImage) {

        var sceneScale =
          1.055 -
          (
            sceneIn *
            .055
          );


        finalSceneImage.style.transform =
          'scale(' +
          sceneScale +
          ')';

      }


      /* =================================================
         BOARD AUSBLENDEN
      ================================================== */

      if (boardStage) {

        var boardFade =
          1 -
          smoothstep(
            rangeProgress(
              progress,
              .73,
              .82
            )
          );


        boardStage.style.opacity =
          boardEnter *
          boardFade;

      }


      /* =================================================
         FINALE GLASS CARD
      ================================================== */

      if (finalCopy) {

        var finalOpacity =
          smoothstep(
            rangeProgress(
              progress,
              .84,
              .92
            )
          );


        finalCopy.style.opacity =
          finalOpacity;


        finalCopy.style.transform =
          'translate(-50%,' +
          (
            (
              1 -
              finalOpacity
            ) *
            35
          ) +
          'px)';


        finalCopy.style.pointerEvents =
          finalOpacity >
          .10
          ? 'auto'
          : 'none';

      }

    }


    function animationLoop() {

      if (!active) return;


      update();


      frame =
        window.requestAnimationFrame(
          animationLoop
        );

    }


    animationLoop();


    section.gbsCleanup =
      function() {

        active =
          false;


        if (frame) {

          window.cancelAnimationFrame(
            frame
          );

        }

      };

  }


  function initAll(
    root
  ) {

    root =
      root ||
      document;


    root
      .querySelectorAll(
        SELECTOR
      )
      .forEach(
        function(
          section
        ) {

          initGilboard(
            section
          );

        }
      );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function() {

        initAll(
          document
        );

      }
    );

  }

  else {

    initAll(
      document
    );

  }


  document.addEventListener(
    'shopify:section:load',
    function(
      event
    ) {

      var section =
        event.target.querySelector(
          SELECTOR
        );


      if (
        !section &&
        event.target.matches &&
        event.target.matches(
          SELECTOR
        )
      ) {

        section =
          event.target;

      }


      if (section) {

        section.dataset.gbsInitialized =
          'false';


        initGilboard(
          section
        );

      }

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function(
      event
    ) {

      var section =
        event.target.querySelector(
          SELECTOR
        );


      if (
        !section &&
        event.target.matches &&
        event.target.matches(
          SELECTOR
        )
      ) {

        section =
          event.target;

      }


      if (
        section &&
        section.gbsCleanup
      ) {

        section.gbsCleanup();

      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gilboard-voucher-terms"] && !Shopify.designMode) return;
  try {
    

(function () {

  function normalizeText(text) {

    return text
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  }


  function setupVoucherTerms() {

    var sections =
      document.querySelectorAll(
        '[data-gvt-content]'
      );


    sections.forEach(
      function (content) {

        if (
          content.dataset.gvtReady ===
          'true'
        ) {
          return;
        }


        content.dataset.gvtReady =
          'true';


        /*
          Wir durchsuchen verschiedene Heading-Ebenen,
          weil ältere Shopify-Inhalte nicht immer
          einheitlich formatiert sind.
        */

        var headings =
          content.querySelectorAll(
            'h1, h2, h3, h4, p, strong'
          );


        headings.forEach(
          function (element) {

            var text =
              normalizeText(
                element.textContent || ''
              );


            /*
              GESCHENKGUTSCHEINE
            */

            if (
              text ===
              'bedingungen für geschenkgutscheine'
            ) {

              element.id =
                'gutscheinbedingungen';

              element.classList.add(
                'gvt-major-heading'
              );

            }


            /*
              RABATTAKTIONEN
            */

            if (
              text ===
              'bedingungen für rabattaktionen und zugaben'
            ) {

              element.id =
                'rabattaktionen';

              element.classList.add(
                'gvt-major-heading'
              );

            }


            /*
              NEWSLETTER
            */

            if (
              text === '3 newsletter' ||
              text === 'newsletter' ||
              text.indexOf(
                'newsletter'
              ) === 0
            ) {

              /*
                Nicht versehentlich normalen
                Fließtext mit Newsletter-Wort markieren.
              */

              if (
                text.length < 35
              ) {

                element.id =
                  'newsletter';

              }

            }

          }
        );

      }
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      setupVoucherTerms
    );

  }

  else {

    setupVoucherTerms();

  }


  document.addEventListener(
    'shopify:section:load',
    setupVoucherTerms
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
